var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVolume0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-762.000000, -2279.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/volume0",
    transform: "translate(762.000000, 2279.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bound",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.24352617,14.7162329 L12.9988615,7.96104717 L13,16.5014 C13,17.7374 11.458,18.4384 10.401,17.6954 L6.24352617,14.7162329 Z M0.802855286,13.2369652 C0.33825056,13.025392 0.002,12.5806181 0.002,12.0514 L0,5.9504 C0,5.2504 0.616,4.6314 1.41,4.6314 L4.362,4.6314 L10.399,0.3044 C11.3358175,-0.35323348 12.6536146,0.121860111 12.9411745,1.09891484 L0.802855286,13.2369652 Z",
    id: "Combined-Shape",
    fill: "#858199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9766,15.9062 C2.6076,15.9062 2.2606,15.7622 1.9986,15.5012 C1.4596,14.9622 1.4596,14.0852 1.9986,13.5462 L13.0456,2.4992 C13.3076,2.2382 13.6546,2.0932 14.0236,2.0932 C14.3926,2.0932 14.7396,2.2382 15.0006,2.4992 C15.5396,3.0382 15.5396,3.9152 15.0006,4.4542 L3.9546,15.5012 C3.6926,15.7622 3.3456,15.9062 2.9766,15.9062",
    id: "Fill-3",
    fill: "#858199"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1.000000, 1.000000)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVolume0);
export default __webpack_public_path__ + "static/media/iconVolume0.b119203a.svg";
export { ForwardRef as ReactComponent };